
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/invitation/napza",
      function () {
        return require("private-next-pages/bcks/invitation/napza.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/invitation/napza"])
      });
    }
  